import { trans } from '@spotahome/soyuz/client';
import { Colors, useCitiesContext } from '@spotahome/ui-library';
import CityAutocompleter from '@spotahome/ui-library/src/tenant/components/CityAutocompleter';

import './FindPlace.scss';

const FindPlace = () => {
  const { cities } = useCitiesContext();

  return (
    <section className="find-place">
      <div className="find-place__text">
        <h2 className="find-place__title">
          {trans('error_page.not_found.find_place.title')}
        </h2>
        <p>{trans('error_page.not_found.find_place.text')}</p>
      </div>
      <CityAutocompleter
        className="find-place__autocompleter"
        cities={cities}
        iconColor={Colors.medium}
      />
    </section>
  );
};

export default FindPlace;
